import { Component, OnInit, OnDestroy } from "@angular/core";
import { ApexOptions } from 'apexcharts';
import { HttpService } from "src/app/services/http/http.service";

@Component({
  selector: "app-superadmindashboard",
  templateUrl: "./superadmindashboard.component.html",
  styleUrls: ["./superadmindashboard.component.scss"],
})
export class SuperadmindashboardComponent implements OnInit {
  activeResturants: string;
  inactiveResturants: string;
  totalResturants: string;
  activeUsers: string;
  inactiveUser: string;
  totalUser: string;

  constructor(private httpsv: HttpService) { }

  ngOnInit(): void {
    this.getRestoUser();
     this.getAdminAnalytics();
  }
  getRestoUser() {
    this.httpsv.getRestoCount().subscribe((res) => {
      let temp = res["result"]["data"];
      this.activeResturants = temp["active_restaurants"];
      this.inactiveResturants = temp["inactive_restaurants"];
      this.totalResturants = temp["total_restaurants"];
      this.activeUsers = temp["active_users"];
      this.inactiveUser = temp["inactive_users"];
      this.totalUser = temp["total_users"];
    });
  }

  //Charts Logic

  readonly chartColors: string[] = [
    '#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EF4444',
    '#06B6D4', '#84CC16', '#F97316', '#EC4899', '#14B8A6',
    '#6366F1', '#22C55E', '#EAB308', '#A855F7', '#F43F5E',
    '#0EA5E9', '#65A30D', '#D97706', '#7C3AED', '#059669'
  ];

  chartsReady = false;
  isLoading = false;

  dashboardData: any = this.getEmptyDashboardPayload();

  dietaryPreferencesChart: ApexOptions = this.createDistributedBarChart([], 'Number of People', 320);
  foodAllergiesChart: ApexOptions = this.createDistributedBarChart([], 'Number of People', 320);
  allergyDistributionChart: ApexOptions = this.createPieChart([], 320);
  preferenceByCategoryChart: ApexOptions = this.createMultiSeriesBarChart(
    {
      categories: [],
      series: [
        { name: 'Vegan', data: [] },
        { name: 'Vegetarian', data: [] }
      ]
    },
    'People Count',
    320
  );


  getAdminAnalytics(range: any = null): void {
    this.isLoading = true;
    this.chartsReady = false;
    this.httpsv.getAdminAnalytics(range).subscribe(
      (res: any) => {

        const apiData = res.result && res.result.data ? res.result.data : {};

        this.dashboardData = this.transformApiResponse(apiData);

        this.buildCharts();
        this.chartsReady = true;
        this.isLoading = false;
      },
      (error: any) => {
        console.error('Dashboard API error:', error);
        this.dashboardData = this.getEmptyDashboardPayload();
        this.buildCharts();
        this.chartsReady = true;
        this.isLoading = false;
      }
    );
  }

  private buildCharts(): void {
    this.dietaryPreferencesChart = this.createDistributedBarChart(
      this.dashboardData.peopleWithDietaryPreferences,
      'Number of People',
      320
    );

    this.foodAllergiesChart = this.createDistributedBarChart(
      this.dashboardData.peopleWithFoodAllergies,
      'Number of People',
      320
    );

    this.allergyDistributionChart = this.createPieChart(
      this.dashboardData.foodAllergyDistribution,
      320
    );

    this.preferenceByCategoryChart = this.createMultiSeriesBarChart(
      this.dashboardData.foodPreferenceByCategory,
      'People Count',
      320
    );
  }

  private transformApiResponse(api: any): any {
    return {
      summaryCards: [
        {
          title: 'Number of Diners',
          value: this.toNumber(api?.dashboard?.no_of_diners),
          subtitle: 'Total diners recorded'
        },
        {
          title: 'With Dietary Preferences',
          value: this.toNumber(api?.dashboard?.with_diet_preferences),
          subtitle: 'Vegan, Vegetarian, Halal, etc.'
        },
        {
          title: 'With Food Allergies',
          value: this.toNumber(api?.dashboard?.with_food_allergies),
          subtitle: 'Various allergen types'
        }
      ],

      peopleWithDietaryPreferences: this.mapXYChart(
        api?.dpa_barchart?.dietary_preference_barchart
      ),

      peopleWithFoodAllergies: this.mapXYChart(
        api?.dpa_barchart?.allergens_barchart
      ),

      foodAllergyDistribution: this.mapXYChart(
        api?.fa_piechart
      ),

      foodPreferenceByCategory: {
        categories: this.getStringArray(api?.fpd_barchart?.x),
        series: [
          {
            name: 'Vegan',
            data: this.getNumberArray(api?.fpd_barchart?.vegan)
          },
          {
            name: 'Vegetarian',
            data: this.getNumberArray(api?.fpd_barchart?.vegetarian)
          }
        ]
      }
    };
  }

  private mapXYChart(chartData: any): any[] {
    const x = this.getStringArray(chartData?.x);
    const y = this.getNumberArray(chartData?.y);

    return x.map((label: string, index: number) => ({
      label: label,
      value: this.toNumber(y[index])
    }));
  }

  private getStringArray(value: any): string[] {
    return Array.isArray(value) ? value.map((item: any) => String(item)) : [];
  }

  private getNumberArray(value: any): number[] {
    return Array.isArray(value) ? value.map((item: any) => this.toNumber(item)) : [];
  }

  private toNumber(value: any): number {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  private getEmptyDashboardPayload(): any {
    return {
      summaryCards: [
        { title: 'Number of Diners', value: 0, subtitle: 'Total diners recorded' },
        { title: 'With Dietary Preferences', value: 0, subtitle: 'Vegan, Vegetarian, Halal, etc.' },
        { title: 'With Food Allergies', value: 0, subtitle: 'Various allergen types' }
      ],
      peopleWithDietaryPreferences: [],
      peopleWithFoodAllergies: [],
      foodAllergyDistribution: [],
      foodPreferenceByCategory: {
        categories: [],
        series: [
          { name: 'Vegan', data: [] },
          { name: 'Vegetarian', data: [] }
        ]
      },
      topCuisineTitle: '',
      topCuisineDishes: [],
      topCategoryTitle: '',
      topCategoryDishes: [],
      complianceItems: [],
      resources: [],
      planningMonths: []
    };
  }

  private createDistributedBarChart(
    items: any[],
    yAxisTitle: string,
    height = 300
  ): ApexOptions {
    const safeItems = items || [];

    return {
      series: [
        {
          name: yAxisTitle,
          data: safeItems.map(item => item.value)
        }
      ],
      chart: {
        type: 'bar',
        height: height,
        toolbar: { show: false },
        fontFamily: 'Inter, sans-serif'
      },
      noData: {
        text: 'No data available'
      },
      colors: safeItems.map((_, index) => this.chartColors[index % this.chartColors.length]),
      plotOptions: {
        bar: {
          distributed: true,
          borderRadius: 6,
          columnWidth: '52%'
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: safeItems.map(item => item.label),
        labels: {
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        title: {
          text: yAxisTitle
        }
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 4
      },
      tooltip: {
        y: {
          formatter: (value: number) => '' + value
        }
      }
    };
  }

  private createPieChart(items: any[], height = 300): ApexOptions {
    const safeItems = items || [];

    return {
      series: safeItems.map(item => item.value),
      labels: safeItems.map(item => item.label),
      chart: {
        type: 'pie',
        height: height,
        fontFamily: 'Inter, sans-serif'
      },
      noData: {
        text: 'No data available'
      },
      colors: safeItems.map((_, index) => this.chartColors[index % this.chartColors.length]),
      legend: {
        position: 'bottom',
        fontSize: '12px'
      },
      dataLabels: {
        enabled: true,
        formatter: (value: number) => value.toFixed(0) + '%'
      },
      tooltip: {
        y: {
          formatter: (value: number) => value + '%'
        }
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: {
              height: 280
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ]
    };
  }

  private createMultiSeriesBarChart(
    input: any,
    yAxisTitle: string,
    height = 300
  ): ApexOptions {
    return {
      series: input.series,
      chart: {
        type: 'bar',
        height: height,
        stacked: false,
        toolbar: { show: false },
        fontFamily: 'Inter, sans-serif'
      },
      noData: {
        text: 'No data available'
      },
      colors: input.series.map((_, index) => this.chartColors[index % this.chartColors.length]),
      plotOptions: {
        bar: {
          borderRadius: 6,
          columnWidth: '48%'
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 0
      },
      xaxis: {
        categories: input.categories
      },
      yaxis: {
        title: {
          text: yAxisTitle
        }
      },
      legend: {
        position: 'bottom'
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 4
      },
      tooltip: {
        shared: true,
        intersect: false
      }
    };
  }



}
